import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Store from 'services/StoreService';
import alertAdmin from 'utils/alertAdmin';
import { displayError } from 'store/actions/errorActions';
import { getNewUserToken } from 'services/providerService';

const xsrfBust = '34fFs29kd09';

export const SpotifyAuthorization = ({ uid, location, displayError }) => {
  const [accessDenied, setAccessDenied] = useState(false);

  const { code, state, error } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const isXsrfAttack = state && state !== xsrfBust;

  useEffect(() => {
    if (!uid) return;
    if (!error && !isXsrfAttack && code) {
      getAccessToken();
    } else if (error === 'access_denied') {
      onAccessDenied();
    }
  }, [uid]);

  if (isXsrfAttack) {
    alertAdmin(
      `Xsrf attack detected during Spotify authorization access for user user ${uid}`
    );
    return <Redirect to='/profile' />;
  }

  const onAccessDenied = async () => {
    const spotifyAuth = { status: 'denied', on: Date.now() };
    await Store.updateUser(uid, { spotifyAuth });
    setAccessDenied(true);
  };

  const getAccessToken = async () => {
    try {
      const data = await getNewUserToken({ uid, code });
      const { error } = data;
      if (error) throw new Error(error);
      const spotifyAuth = { status: 'authorized', on: Date.now() };
      await Store.updateUser(uid, { spotifyAuth });
      window.location.replace('/');
    } catch (error) {
      console.error(error);
      displayError('Could not get Spotify auhtorization');
    }
  };

  if (accessDenied) {
    return <Redirect to='/profile' />;
  }

  return (
    <h3
      style={{
        textAlign: 'center',
        marginTop: '300px',
      }}
    >
      {!error && 'Authorizing...'}
      {error === 'access_denied' && 'Access Denied'}
      {!!error && 'Authorization Failed'}
    </h3>
  );
};

const mapStateToProps = (state) => {
  const { uid } = state.user;
  return { uid };
};

export default connect(mapStateToProps, { displayError })(SpotifyAuthorization);
